import type { IPromotionRepository, BulkPromotionStatusInput } from '@/features/promotion/domain/repositories/IPromotionRepository.js';

export const createBulkSetEnabledUseCase = ({ promotionRepository }: { promotionRepository: IPromotionRepository }) =>
  (input: BulkPromotionStatusInput) => promotionRepository.bulkSetEnabled(input);
